import { createTheme } from "@mui/material/styles";
import borders from "theme/base/borders";
import breakpoints from "theme/base/breakpoints";
import colors from "theme/theme-light/colors";
import globals from "theme/base/globals";
import typography from "theme/base/typography";
import hexToRgb from "theme/base/hexToRgb";
import pxToRem from "theme/base/pxToRem";
import rgba from "theme/base/rgba";
import button from "theme/theme-light/components/button";
import container from "theme/theme-light/components/container";
import list from "theme/theme-light/components/list";
import listItem from "theme/theme-light/components/list/listItem";
import listItemText from "theme/theme-light/components/list/listItemText";
import icon from "./components/icon";
import card from "./components/card";
import cardHeader from "./components/cardHeader";
import tab from "./components/tabs/tab";
import tabs from "./components/tabs/tabs";
import muiTypography from "./components/muiTypography/muiTypography";
import dateCalendar from "./components/calendar/dateCalendar";
import dayCalendar from "./components/calendar/dayCalendar";
import inputOutlined from "./components/inputOutlined";
export const themeLight = createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  borders: { ...borders },
  functions: {
    hexToRgb,
    pxToRem,
    rgba,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...container,
      },
    },
    MuiButton: { ...button },
    MuiIcon: { ...icon },
    MuiList: { ...list },
    MuiListItem: { ...listItem },
    MuiListItemText: { ...listItemText },
    MuiCard: { ...card },
    MuiCardHeader: { ...cardHeader },
    MuiTab: { ...tab },
    MuiTabs: { ...tabs },
    MuiTypography: { ...muiTypography },
    MuiDateCalendar: { ...dateCalendar },
    MuiDayCalendar: { ...dayCalendar },
    MuiInputOutlined: { ...inputOutlined },
    
  },
} as any);
